module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_note_3.e7bc001.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_note_3.png
// module id = i57a
// module chunks = 5